import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import 'drag-drop-touch';

import App from './App';
import './styles/index.scss';

Sentry.init({
  dsn: 'https://77d3dbbd60d1750832c17de0a8772de9@sentry.finch.fm/107',
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  tracesSampleRate: 1.0,
  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
